import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import axios from "axios";

import { Button, Modal, CardContent } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';

import i18n from "locales/i18n";
import MainCard from "components/MainCard";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals';
import { customFileAxios } from "components/axios/customAxios";

const MaterSpecExcelUploadLayer = ({ setIsLoading }) => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false);

    const [excelFile, setExcelFile] = useState();
    const [fileLoading, setFileLoading] = useState(false);

    const { handleSubmit} = useForm({});
    
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose: () => { },
            message: alertMessage,
        });
    };

    const handleExelUpload = (data, e) => {
        e.preventDefault();
        setFileLoading(true);

        if (!excelFile) {
            alertMessage = t('message.common.alert.excel.file.write');
            setAlertMessage(alertMessage);
            handleAlertClick();
            setFileLoading(false);
            return;
        }

        let formData = new FormData();
        formData.append("file", excelFile);

        try {
            openModal(modals.confirmModal, {
                onSubmit : (value) => {
                    try {
                        const res = customFileAxios.post(`/api/masterEquipmentParts/specKeys:withExcel`, formData).then((res)=>{
                            alertMessage = t('message.common.alert.write.done');
                            setAlertMessage(alertMessage);
                            handleAlertClick();
                            setFileLoading(false);
                            setIsLoading(false);
                        }).catch((err)=>{
                            console.log(err);
                            setFileLoading(false);
                            if (!err.response?.data?.message) {
                                alertMessage = err.message;
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                            } else if (err.response.data.message) {
                                alertMessage = err.response.data.message;
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                            }
                        });
                        // return res.data;
                    } catch (error) {
                        console.error("error :", error);
                        throw error;
                    }
                    
                    // axios({
                    //     method: "post",
                    //     url: process.env.REACT_APP_API_URL+"/api/masterEquipmentParts/specKeys:withExcel",
                    //     data: formData,
                    //     headers : {
                    //         'Content-type' : 'multipart/form-data',
                    //         accept : 'application/json,',
                    //         'Authorization': `Bearer ${localStorage.getItem("persist:root") && JSON.parse(localStorage.getItem("persist:root")).authToken && JSON.parse(JSON.parse(localStorage.getItem("persist:root")).authToken).accessToken}`,
                    //         'Accept-Language' : t('locale')
                    //     }
                    // }).then((res)=>{
                    //     // parentSetIsLoading(false);
                    //     alertMessage = t('message.common.alert.write.done');
                    //     setAlertMessage(alertMessage);
                    //     handleAlertClick();
                    //     setFileLoading(false);
                    //     setIsLoading(false);
                    // }).catch((err)=>{
                    //     console.log(err);
                    //     setFileLoading(false);
                    //     if (!err.response?.data?.message) {
                    //         alertMessage = err.message;
                    //         setAlertMessage(alertMessage);
                    //         handleAlertClick();
                    //     } else if (err.response.data.message) {
                    //         alertMessage = err.response.data.message;
                    //         setAlertMessage(alertMessage);
                    //         handleAlertClick();
                    //     }
                    // });
                },
                onClose : () => {
                    setFileLoading(false);
                },
                message: t('message.common.alert.write.question'),
            });
        } catch(error) {
            console.log(error);
            setFileLoading(false);
        }
    };

    const sampleDownload = () => {
        if(i18n.language === 'ko') {
            window.location.href = '/SpecKey(sample).xlsx';
        } else if (i18n.language === 'zh') {
            window.location.href = '/SpecKey(sample)-zh.xlsx';
        }
    }

    return (
        <>
            <Button variant="contained" color='success' onClick={() => setOpen(true)}>
                Excel {t('message.common.chip.spec')} {t('message.common.btn.write')}
            </Button>

            <Modal className="pop_box" open={open} onClose={() => setOpen(false)}>
                <MainCard title={`Excel ${t('message.common.chip.spec')} ${t('message.common.btn.write')}`} modal darkTitle content={false} style={{ width: "900px" }}>
                    <div style={{ marginTop: "-40px", marginRight: "12px", textAlign: "right" }}>
                        <Button variant="contained" color="primary" size="small" onClick={() => setOpen(false)}>
                            {t('message.common.btn.close')}
                        </Button>
                    </div>
                    <CardContent>
                        <form onSubmit={handleSubmit(handleExelUpload)}>
                            <div className='modal_imagelayer_img modal_imagelayer_img1'>
                                <div style={{width:"unset"}}>
                                    <span>Excel</span>
                                    <div style={{display:"flex", justifyContent: "space-between"}}>
                                        <div>
                                            <input
                                                type="file" 
                                                accept=".xlsx" 
                                                onChange={(e)=>{
                                                    setExcelFile(e.target.files[0]);
                                                }}
                                            />
                                        </div>
                                        <div style={{cursor:"pointer"}} onClick={() => {sampleDownload()}}>
                                            Excel Sample File<ArchiveOutlinedIcon fontSize="small" ></ArchiveOutlinedIcon>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{"marginTop": "10px",display: "flex","justifyContent": "flex-start", alignItems:"center", color:"#000"}}>
                                <LoadingButton variant="contained" color="info" loading={fileLoading} onClick={handleSubmit(handleExelUpload)}>{t('message.common.btn.write')}</LoadingButton>
                                <span style={{marginLeft:"5px"}}>* {t('message.common.guide.download.excel.instruction')}</span>
                            </div>
                        </form>
                    </CardContent>
                </MainCard>
            </Modal>
        </>
    );
};

export default MaterSpecExcelUploadLayer;
